import React from 'react';
import { StyledHeaderContainer, StyledPaperContainer } from '../../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import useClinicMasterProductForm from '../../hooks/useClinicMasterProductForm';
import { CreateClinicMasterProductFooter } from './CreateClinicMasterProductFooter';
import { ColumnWithGap } from '../../../PlusWebsiteEditor/sections/HeroBlock/HeroBlock.styled';
import ClinicMasterProductMasterMedicineSelectorEditor from '../Editors/ClinicMasterProductMasterMedicineSelectorEditor';
import ClinicVirtualProductEditor from '../../../ClinicProduct/components/Editors/ClinicProductsTableEditor';
import useClinicProductsForm from '../../../ClinicProduct/hooks/useClinicProductForm';
import { useSuggestedProducts } from '../hooks/useSuggestedProducts';
import ClinicMasterProductDeliveryPriceEditor from '../Editors/ClinicMasterProductDeliveryPriceEditor';
import useClinicById from '../../../Clinics/ModifyClinic/hooks/useClinicById';
import GlobalDefaultClinicBanner from '../../../Clinics/ModifyClinic/components/GlobalDefaultClinicBanner';

interface ClinicMasterProductProps {
  clinicId: string;
}

const CreateClinicMasterProduct = ({ clinicId }: ClinicMasterProductProps) => {
  const form = useClinicMasterProductForm({ clinic_id: clinicId });
  const { clinic } = useClinicById(clinicId);

  const masterMedicineId = form.watch('master_medicine_id');

  const productsForm = useClinicProductsForm();

  useSuggestedProducts(productsForm, masterMedicineId);

  const isGlobalDefaultClinic = clinic?.selection_visibility === 'global_default';

  return (
    <ColumnWithGap>
      <StyledHeaderContainer />
      
      {isGlobalDefaultClinic && clinic && (
        <GlobalDefaultClinicBanner />
      )}
      
      <StyledPaperContainer>
        <ColumnWithGap>
          <ClinicMasterProductMasterMedicineSelectorEditor form={form} />
          <ClinicMasterProductDeliveryPriceEditor form={form} />
          <ClinicVirtualProductEditor form={productsForm} />
        </ColumnWithGap>
      </StyledPaperContainer>
      <CreateClinicMasterProductFooter productsForm={productsForm} form={form} />
    </ColumnWithGap>
  );
};

export default CreateClinicMasterProduct;
